import { useState } from 'react';
import { Input, Select, Modal, Textarea } from '@bigcommerce/big-design';

const LINE_ITEM_FIELD_LABELS = {
	part_number: 'Part Number',
	color: 'Color',
	year: 'Year',
	make: 'Make',
	model: 'Model',
	sub_model: 'Sub Model',
	row: 'Row',
	seat: 'Description',
	notes: 'Comment',
};

export function LineItemEditForm({
	lineItem,
	onCancel,
	onComplete,
	colorOptions,
}) {
	const [editableLineItem, setEditableLineItem] = useState(lineItem);

	function getColorSelectedValue(values, selected) {
		let selectedId = 0;
		values.forEach((color) => {
			if (selected === color.label) selectedId = color.id;
		});

		return selectedId;
	}

	function getColorOptions(colorOptions) {
		let options = [];
		colorOptions.forEach((color) => {
			options.push({
				value: color.id,
				content: color.label,
			});
		});

		return options;
	}

	function getColorLabelSelectedById(colorOptions, selectedId) {
		let color = '';

		colorOptions.forEach((colorOption) => {
			if (colorOption.id === selectedId) color = colorOption.label;
		});

		return color;
	}

	return (
		<Modal
			header={`Edit Part #${lineItem.part_number}`}
			isOpen={true}
			closeOnClickOutside={true}
			onClose={onCancel}
			actions={[
				{ text: 'Cancel', variant: 'secondary', onClick: onCancel },
				{
					text: 'Apply',
					variant: 'primary',
					onClick: () => onComplete(editableLineItem),
				},
			]}
		>
			<div
				tabIndex="0"
				style={{
					width: 0,
					height: 0,
					overflow: 'hidden',
					outline: 'none',
				}}
			/>
			<form
				style={{
					margin: '2rem',
					display: 'grid',
					gridTemplateColumns: '1fr 3fr',
					rowGap: '1rem',
				}}
			>
				{Object.keys(LINE_ITEM_FIELD_LABELS)
					.filter(
						(property) =>
							editableLineItem[property] !== undefined,
					)
					.map((property) => (
						<>
							<p className="modal-label">
								{LINE_ITEM_FIELD_LABELS[property]}
							</p>
							{LINE_ITEM_FIELD_LABELS[property] === 'Color' ? (
								<Select
									value={getColorSelectedValue(
										colorOptions,
										editableLineItem[property],
									)}
									onOptionChange={(value) =>
										setEditableLineItem({
											...editableLineItem,
											[property]:
												getColorLabelSelectedById(
													colorOptions,
													value,
												),
										})
									}
									options={getColorOptions(colorOptions)}
								/>
							) : LINE_ITEM_FIELD_LABELS[property] ===
								'Description' ? (
								<Textarea
									rows={4}
									value={editableLineItem[property]}
									onChange={(event) =>
										setEditableLineItem({
											...editableLineItem,
											[property]:
												event.currentTarget.value,
										})
									}
								/>
							) : (
								<Input
									value={editableLineItem[property]}
									onChange={(event) =>
										setEditableLineItem({
											...editableLineItem,
											[property]:
												event.currentTarget.value,
										})
									}
								/>
							)}
						</>
					))}
			</form>
		</Modal>
	);
}
